import { render, staticRenderFns } from "./AddBanner.vue?vue&type=template&id=66e14ee8&scoped=true&"
import script from "./AddBanner.vue?vue&type=script&lang=js&"
export * from "./AddBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e14ee8",
  null
  
)

export default component.exports